import { useEffect, useState, useRef, ChangeEvent } from "react";
import toast, { Toaster } from "react-hot-toast";
import ContentLayout from "..//components/ContentLayout";
import Datagrid from "..//components/Datagrid/Datagrid";
import CreateEditDeleteButtonGroup from "..//components/CreateEditDeleteButtonGroup";
import { BackendApi } from "../utils/BackendApi";
import { SelectionChangedEvent, ColDef } from "ag-grid-community";
import "bootstrap/dist/css/bootstrap.min.css";
import common from "..//utils/common";
import { ApiRoute } from "..//utils/ApiRoute";
import { useWindowSize } from "../hooks/useWindowSize";
import { AxiosError, AxiosResponse } from "axios";
import moment from "moment";
import RecordSearchInput from "..//components/Datagrid/RecordSearchInput";
import { cal_cron } from "../class/prisma/db";
import { AgGridReact } from "ag-grid-react";
import { SystemMsg } from "../utils/SystemMsg";
import "bootstrap/dist/css/bootstrap.css";
import "./page.css";
import { SearchCronRequest, CronJobViewObject } from "../class/cron.schema";
import CronModal from "../components/Modal/CronModal";

import { Button } from "react-bootstrap";
import { FaPlay } from "react-icons/fa";
import { useI18n } from "../i18n";

const Title = () => {
  const { t } = useI18n();
  const title = t("nav.cron") + " - " + t("meta.appName");
  return (
    <>
      <title>{title}</title>
    </>
  );
};
const Content = () => {
  const gridRef = useRef<AgGridReact>(null);

  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [crudMode, setCrudMode] = useState("view");
  const [showSingleModal, setShowSingleModal] = useState(false);
  const [showMultiModal, setShowMultiModal] = useState(false);

  const [modalDataObj, setModalDataObj] = useState<
    CronJobViewObject | cal_cron[] | undefined
  >(undefined);

  const [rowData, setRowData] = useState<any[]>();
  const [rowLoaded, setRowLoaded] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(common?.pageSizeArray[1]);
  const [pageCount, setPageCount] = useState(0);
  const [paginationPage, setPaginationPage] = useState(0);

  //Search
  const [keyword, setKeyword] = useState("");

  const { height } = useWindowSize();
  const colDefs = [
    { field: "id", width: "70" },
    { field: "name", width: "200" },
    {
      field: "description",
      flex: 3,
    },
    {
      field: "Action",
      width: "200",
      cellRenderer: (params: any) => {
        return (
          <Button
            variant="light"
            style={{ padding: "4px 10px" }}
            onClick={() => {
              runCron(params.data.name);
            }}
          >
            <FaPlay style={{ marginRight: "2px", fontSize: "0.78rem" }} /> Run
          </Button>
        );
      },
    },
    // {
    //   field: "cronValue",
    //   headerName: "Cron Exp",
    //   width: "150",
    // },
    // {
    //   field: "nextRunDate",
    //   headerName: "Next Run",
    //   width: "150",
    //   cellRenderer: (params: any) => {
    //     return dateRenderer(params);
    //   },
    // },
    // {
    //   field: "enabled",
    //   width: "200",
    // },
    // {
    //   field: "registered",
    //   width: "200",
    // },
  ] as ColDef[];

  const dateRenderer = (param: any) => {
    if (!param || !param.value) {
      return "";
    }
    if (!param.value) {
      return "";
    }

    const dateObj = moment(param.value);
    if (!dateObj.isValid()) {
      return "Invalid Date";
    }
    return dateObj.format(`YYYY-MM-DD HH:mm`);
  };

  const getSearchParam = () => {
    const searchParam: SearchCronRequest = {
      page: page > 0 ? page : 1,
      pageSize: pageSize,
    };
    if (
      !common.stringIsNullOrEmpty(keyword) &&
      keyword.toString().trim().length > 0
    ) {
      searchParam[`keyword`] = keyword;
    }
    return searchParam;
  };
  const getRowData = () => {
    //common.setDataGridLoading(gridRef, true);
    BackendApi.get(
      ApiRoute.cron,
      getSearchParam(),
      (resp) => {
        //common.setDataGridLoading(gridRef, false);
        const total =
          resp.data.total != null && !Number.isNaN(resp.data.total.toString())
            ? resp.data.total
            : 0;
        setPageCount(common.getPageCount(total, pageSize));
        if (Array.isArray(resp.data.data)) {
          setRowData(resp.data.data);
        } else {
          setRowData([]);
        }
        setRowLoaded(true);
      },
      (resp) => {
        // common.setDataGridLoading(gridRef, false);
        toast.error(SystemMsg.Record.failedToLoadRecord);
        console.log(resp);
        setRowLoaded(true);
      },
    );
  };

  const onSelectionChanged = (event: SelectionChangedEvent) => {
    if (
      !event ||
      !event.selectedNodes ||
      event.selectedNodes === null ||
      !Array.isArray(event.selectedNodes) ||
      event.selectedNodes.length === 0
    ) {
      setSelectedIds([]);
      return;
    }
    const selectedNode = event.selectedNodes;
    setSelectedIds(
      selectedNode
        .filter((x) => Number.isInteger(Number(x.data.id)))
        .map((x) => Number(x.data.id)),
    );
  };

  const runCron = (jobName: string) => {
    BackendApi.get(
      `${ApiRoute.cron}/run/${jobName}`,
      {},
      (resp: AxiosResponse) => {
        const success = resp.status >= 200;
        if (success) {
          toast.success(SystemMsg.Cron.cronRunSuccess(jobName));
        }
      },
      (resp: AxiosResponse | string) => {
        const response = resp as AxiosResponse;
        const errMessage = response?.data?.message ?? "";
        if (errMessage.length === 0) {
          toast.error(SystemMsg.Cron.cronRunFailed(jobName));
          return;
        }
        toast.error(errMessage);
      },
    );
  };

  const onModalClose = () => {
    setCrudMode("");

    if (showSingleModal) {
      setShowSingleModal(false);
    }

    if (showMultiModal) {
      setShowMultiModal(false);
    }

    setModalDataObj(undefined);
    setSelectedIds([]);
    gridRef?.current?.api?.deselectAll();
  };

  const deleteRecord = (dataObj: any, callbackFunc: (record: any) => void) => {
    if (!dataObj.id) {
      toast.error(SystemMsg.Record.failedToFindRecordId);
      return;
    }
    const id = dataObj.id;
    BackendApi.delete(
      `${ApiRoute.cron}/${id}`,
      {},
      (resp: AxiosResponse) => {
        const success = resp.status >= 200;
        if (success) {
          toast.success(SystemMsg.Record.deleteSuccess(id));
          if (typeof callbackFunc === "function") {
            callbackFunc(dataObj);
          }
        }
      },
      (resp: AxiosResponse | string) => {
        const response = resp as AxiosResponse;
        const errMessage = response?.data?.message ?? "";
        if (errMessage.length === 0) {
          toast.error(SystemMsg.Record.deleteFailed(id));
          return;
        }
        toast.error(errMessage);
      },
    );
  };

  const onCreateButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setCrudMode("add");
    setShowSingleModal(true);
    setModalDataObj(undefined);
  };

  const onEditButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!rowData) {
      toast.error(SystemMsg.GridUi.emptyData);
      return;
    }

    if (!Array.isArray(selectedIds) || selectedIds.length === 0) {
      toast.error(SystemMsg.GridUi.emptySelection);
      return;
    }

    const singleSelect = selectedIds.length === 1;

    setCrudMode("edit");

    if (singleSelect) {
      const find = rowData?.find((x) => x.id === selectedIds[0]);
      if (!find || find.length === 0) {
        toast.error(SystemMsg.GridUi.emptySelection);
        return;
      }
      setModalDataObj(find);
      setShowSingleModal(true);
    } else {
      const filter = rowData?.filter((x) => selectedIds.includes(Number(x.id)));
      if (!filter || filter.length === 0) {
        toast.error(SystemMsg.GridUi.emptySelection);
        return;
      }
      setModalDataObj(filter);
      setShowMultiModal(true);
    }
  };

  const onDeleteButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const singleSelect = selectedIds.length === 1;
    if (singleSelect) {
      const find = rowData?.find((x) => x.id === selectedIds[0]);
      if (!find || find.length === 0) {
        toast.error(SystemMsg.GridUi.emptySelection);
        return;
      }
      deleteRecord(find, (record: any) => {
        gridRef?.current?.api.applyTransaction({ remove: [find] });
        const findIdx = rowData?.indexOf(find);
        if (!findIdx) {
          return;
        }
        rowData?.splice(findIdx, 1);
      });
      return;
    }
    const filter = rowData?.filter((x) => selectedIds.includes(Number(x.id)));
    if (!filter || filter.length === 0) {
      toast.error(SystemMsg.GridUi.emptySelection);
      return;
    }
    setCrudMode("delete");
    setModalDataObj(filter);
    setShowMultiModal(true);
  };

  const topMenuElement = (
    <CreateEditDeleteButtonGroup
      onCreateButtonClick={onCreateButtonClick}
      onEditButtonClick={onEditButtonClick}
      onDeleteButtonClick={onDeleteButtonClick}
      hasEdit={true}
      disableEdit={selectedIds.length === 0 || selectedIds.length > 1}
      hasDelete={selectedIds.length > 0}
    />
  );

  useEffect(() => {
    getRowData();
  }, []);

  useEffect(() => {
    setPage(1);
    setPaginationPage(0);
  }, [pageSize]);

  useEffect(() => {
    const debounce = setTimeout(() => {
      if (rowLoaded) {
        getRowData();
      }
    }, common.DEBOUNCE_TIME);
    return () => clearTimeout(debounce);
  }, [keyword]);

  useEffect(() => {
    if (rowLoaded) {
      getRowData();
    }
  }, [page, pageSize]);

  const handlePageClick = (event: { selected: number }) => {
    if (!event || event?.selected == null || Number.isNaN(event.selected)) {
      return;
    }
    setPage(event.selected + 1);
    setPaginationPage(event.selected);
  };

  const handlePageSizeChange = (event: ChangeEvent<HTMLSelectElement>) => {
    if (
      !event ||
      !event?.target ||
      event?.target?.value == null ||
      Number.isInteger(event?.target?.value)
    ) {
      return;
    }
    setPageSize(Number(event.target.value));
  };

  const topLeftElement = (
    <RecordSearchInput searchValue={keyword} setSearchValueFunc={setKeyword} />
  );

  const onSaveBtnClick = (
    resp: AxiosResponse | AxiosError,
    mode?: string,
    sendData?: any,
  ) => {
    const success = resp.status === 200;
    const isAdd = mode === "add";
    if (!success) {
      const resp_data = (resp as AxiosError).response?.data as any;
      // const message = resp?.response?.data?.message;
      toast.error(
        isAdd
          ? (resp_data[`message`] ?? SystemMsg.Record.createFailed)
          : (resp_data[`message`] ??
              SystemMsg.Record.updateFailed(sendData?.id ?? -1)),
      );
      return;
    }

    const data = (resp as AxiosResponse).data as CronJobViewObject;
    if (isAdd) {
      toast.success(SystemMsg.Cron.createSuccess(data.id.toString()));
      getRowData();
    } else {
      if (!rowData) {
        toast.error(SystemMsg.GridUi.emptyData);
        return;
      }

      if (data.id && data.id.toString().length > 0) {
        data.id = Number(data.id);
      }
      const find = rowData?.find((x) => x.id.toString() === data.id.toString());
      const findIdx = rowData?.indexOf(find);
      if (!find || findIdx === undefined || findIdx < 0) {
        toast.error(SystemMsg.GridUi.doesNotIncludeRecord(data.id));
        return;
      }
      const tempArray = [data];
      rowData[findIdx] = tempArray[0];
      const rowNode = gridRef?.current?.api?.getRowNode(findIdx.toString());
      rowNode?.setData(tempArray[0]);
      toast.success(SystemMsg.Cron.updateSuccess(data.id.toString()));
    }
  };

  const getPageSizeArray = () => {
    const temp = [...common.pageSizeArray];
    temp.shift();
    return temp;
  };

  return (
    <>
      <Datagrid
        rowSelect="singleRow"
        gridRef={gridRef}
        rowData={rowData}
        colDefs={colDefs}
        onSelectionChanged={onSelectionChanged}
        topLeftElement={topLeftElement}
        topRightElement={topMenuElement}
        hasControls={true}
        hasPagination
        handlePageClick={handlePageClick}
        handlePageSizeChange={handlePageSizeChange}
        paginatePage={paginationPage}
        paginatePageCount={pageCount}
        paginatePageSizeArray={getPageSizeArray()}
        windowHeight={height}
      />
      <CronModal
        toast={toast}
        mode={crudMode}
        show={showSingleModal}
        data={modalDataObj as CronJobViewObject}
        onSaveBtnClick={onSaveBtnClick}
        onClose={onModalClose}
      />
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          className: "",
          style: common.toasterStyle,
        }}
      />
    </>
  );
};
const Cron = () => {
  return (
    <ContentLayout
      isFluid={true}
      maxWidth="80vw"
      header={<Title />}
      content={<Content />}
    />
  );
};
export default Cron;
